import React, { Component } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import LeftMenuLink from './LeftMenuLink';

const styles = theme => ({
  root: {
    width: '100%'
  },
  heading: {
    fontSize: '1.3rem',
    color: 'rgba(0, 0, 0, 0.541176)',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif'
  },
  details: {
    width: '100%',
    padding: '0'
  }
});

type Props = {
  classes: any,
  group: any,
  pathname: string,
  resources: any,
  title: string,
  translate: any
};

class LeftMenuGroup extends Component<Props>{
  state = {
    expanded: false,
    filteredResources: []
  };

  componentDidMount() {
    const filteredResources = this.props.resources.filter((resource) => (
      resource.hasList && resource.options.group === this.props.group));
    const expanded = filteredResources.some((resource) => (
      '/' + resource.name === this.props.pathname));

    this.setState({ expanded: expanded, filteredResources: filteredResources });
  }

  handleChange = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  render() {
    return (
      <div className={this.props.classes.root}>
        {
          this.state.filteredResources.length > 0 ?
            <ExpansionPanel expanded={this.state.expanded} onChange={this.handleChange}>
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <Typography className={this.props.classes.heading}>{this.props.title}</Typography>
              </ExpansionPanelSummary>

              {this.state.filteredResources.map((resource, index) => (
                <ExpansionPanelDetails key={index} className={this.props.classes.details}>
                  <LeftMenuLink resource={resource} translate={this.props.translate} />
                </ExpansionPanelDetails>
              ))}
            </ExpansionPanel>
            : null
        }
      </div>
    );
  }
}

export default withStyles(styles)(LeftMenuGroup);



// WEBPACK FOOTER //
// ./src/views/Framework/LeftMenuGroup.tsx